// extracted by mini-css-extract-plugin
export default {"background":"styles_background__a5wVN","dark":"styles_dark__iZuld","spinner":"styles_spinner__pLc69","hidden":"styles_hidden__gdsAm","circ-anim":"styles_circ-anim__Po7lo"};